import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { CommonMessageWidget } from "@eforall/common";
import { ScheduleViewerPart } from "../../../schedule/schedule-viewer/schedule-viewer.part";
import { AccTeamDialogDataService } from "../acc-team-dialog-data.service";

@Component({
	selector: 'acc-team-overlapping-meetings-part',
	standalone: true,
	imports: [
		ScheduleViewerPart,
		CommonMessageWidget,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './overlapping-meetings.part.html',

})
export class AccTeamOverlappingMeetingsPart {

	public readonly dialogDataService = inject(AccTeamDialogDataService);

}